import EventEmitter from '@/common/lib/widget/core/EventEmitter.js';
// 事件总线
export default new EventEmitter();
